<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter" query-api="partsDeliveryTaskQuery"
                                $_em-custom-vuex-mixin_vo="partsVo"
                                $_em-custom-vuex-mixin_filter="partsFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesInventoryDeliveryTaskResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                                      query-api="partsDeliveryTaskQuery"
                                      withCustomRowActions
                                      $_em-custom-vuex-mixin_vo="partsVo"
                                      $_em-custom-vuex-mixin_entity="partsEntity"
                                      $_em-custom-vuex-mixin_filter="partsFilter"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #customRowActions="{row}">
                                    <b-button-group>
                                        <em-button type="gotoChild"
                                            v-bind:class="'btn btn-outline-primary btn-sm'"
                                            @click="gotoChild(row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                                <template #left-header>
                                    <!-- <em-button type="add"
                                    v-b-modal.bom-tree-modal
                                    custom-label="添加BOM"
                                    custom-icon="fa fa-fw fa-lg fa-tasks"
                                    :disabled="actionDisabled('selectOne')"
                                    v-bind:class="'btn btn-outline-primary btn-sm'"
                                    >

                                    </em-button> -->
                                    <!-- 添加BOM改到生产终检转交页面此处先屏蔽 -->
                                    <!-- <em-button type="edit" custom-icon="fa fa-fw fa-lg fa-list"
                                        :disabled="actionDisabled('selectOne')"
                                        custom-label="添加BOM"
                                        :showName="true"
                                        v-bind:class="'btn btn-outline-primary btn-sm'"
                                        @click="openBomDialog()"
                                    >
                                    </em-button> -->

                                    <em-button type="edit" custom-icon="fa fa-fw fa-lg fa-list"
                                        :disabled="actionDisabled('selectOne')"
                                        custom-label="添加物料"
                                        :showName="true"
                                        v-bind:class="'btn btn-outline-primary btn-sm'"
                                        @click="openMaterialAdd()"
                                    >
                                    </em-button>
                                    <em-button type="save" custom-icon="fa fa-fw fa-lg fa-undo-alt"
                                        :disabled="actionDisabled('select')"
                                        custom-label="退回转交"
                                        v-bind:class="'btn btn-outline-primary btn-sm'"
                                        :busy="onComplete"
                                        @click="returnTasks()"
                                        confirm-text="确定退回选中的转交任务？"
                                    >
                                    </em-button>
                                    <em-button type="edit" custom-icon="fa fa-fw fa-lg fa-list"
                                        :disabled="actionDisabled('selectOne')"
                                        custom-label="扫码添加物料"
                                        :showName="true"
                                        v-bind:class="'btn btn-outline-primary btn-sm'"
                                        @click="openScannerDialog()"
                                    >
                                    </em-button>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <!-- <b-modal id="bom-tree-modal" title="选择BOM" @ok="addBomToDeliveryTask()">
            <bom-tree ref="bomTree"></bom-tree>
        </b-modal> -->
        <el-dialog title="添加BOM" :visible.sync="bomDialogVisible" :close-on-click-modal='false' append-to-body @close='clearBomData'>
            <el-form :inline="true" :model="filterForm" label-position="left" label-width="60px">
                <el-form-item label="描述">
                    <el-input v-model="filterForm.filterString"></el-input>
                </el-form-item>
                <el-form-item label="物料号">
                    <el-input v-model="filterForm.filterString2"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :disabled="filterForm.filterString === ''" @click="searchBom">搜索</el-button>
                </el-form-item>
            </el-form>
            <div class="tree-bom-div">
                <el-tree ref="elBomTree" :data="treeData" :props="defaultProps" :load="loadNode" lazy show-checkbox @check-change="checkChange" node-key="id" empty-text="输入关键字搜索BOM">
                </el-tree>
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button @click="bomDialogVisible = false">取消</el-button>
                <!-- <el-button type="primary" @click="bomDialogVisible()" :disabled="noBomSelected()">添加</el-button> -->
                <el-button type="primary" @click="addBomToDeliveryTask()">添加</el-button>
            </div>
        </el-dialog>
        <el-dialog title="添加物料" :visible.sync="materialDialogVisible" :close-on-click-modal='false' append-to-body @close='clearMaterial'>
            <!-- <el-table :data="material.filter(data => !search || data.materialDescription.includes(search.toLowerCase()))" ref="materialTable"
                style="width:100%" max-height="250px" @selection-change="handleSelectionChange"> -->
                <el-form :inline="true" :model="filterForm" label-position="left">
                    <el-form-item label="描述">
                        <el-input v-model="filterForm.filterString"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" :disabled="filterForm.filterString === ''" @click="searchMaterial()">搜索</el-button>
                    </el-form-item>
                </el-form>
                <el-table :data="material" ref="materialTable" style="width:100%" max-height="250px" @selection-change="handleSelectionChange">
                    <el-table-column
                        type="selection"
                        width="55">
                    </el-table-column>
                    <el-table-column label="品名"  prop="materialDescription"></el-table-column>
                    <el-table-column label="物料号" prop="material"></el-table-column>
                    <!-- 目前基础数据物料中没有数量字段 -->
                    <el-table-column label="转交数量" prop="standardPrice"></el-table-column>
                    <!-- <el-table-column align="right">
                        <template slot="header" slot-scope="scope">
                            <el-input v-model="search" size="mini" placeholder="请输入关键字搜索"></el-input>
                        </template>
                    </el-table-column> -->
                </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="materialDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="addMaterial()" :disabled="materialSelection.length == 0">确认添加</el-button>
            </div>
        </el-dialog>
        <el-dialog title="扫码添加物料" :visible.sync="scanMaterialDialogVisible" :close-on-click-modal='false' append-to-body @close='clearMaterial'>
            <el-table :data="material" ref="materialTable" style="width:100%" max-height="350px" empty-text="请点击打开扫码框扫码" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column label="品名"  prop="deliveryDescription"></el-table-column>
                <el-table-column label="物料号" prop="materialCode"></el-table-column>
                <el-table-column label="单位" prop="unit"></el-table-column>
                <el-table-column label="转交数量" prop="quantity"></el-table-column>
            </el-table>
            <el-dialog title="扫一扫" :center="true" :visible.sync="innerScannerVisible" append-to-body @close="closeScannerDialog" :close-on-click-modal="false">
                <qr-code-scanner ref="scanner" @getCodeData="getCodeData"></qr-code-scanner>
            </el-dialog>
            <div slot="footer" class="dialog-footer">
                <el-button @click="openCamera()">扫码</el-button>
                <el-button @click="scanMaterialDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="addScannedMaterial()" :disabled="materialSelection.length == 0">确认添加</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    // Author Lin
    // Date 2021-05-24 20:46:26

    import emCommonListMixin from "@/mixin/em/common/list";
    import emCommonGotoMixin from "@/mixin/em/common/goto";
    import emCommonApiMixin from "@/mixin/em/common/api";
    import bomTree from "@/components/em/EmBusiness/bomTree";
    import qrCodeScanner from "@/components/QRCode/QRCodeScannerForInventory";

    export default {
        name: "sithMesInventoryPartsDeliveryTaskListView",
        mixins: [emCommonListMixin,emCommonGotoMixin,emCommonApiMixin,qrCodeScanner],
        components: {bomTree,qrCodeScanner},
        props:{
            //是否启用行编辑
            prop_inline: {
                type: String,
                default: "0"
            }
        },
        data() {
            return {
                // 手动添加基础数据物料对话框是否显示
                materialDialogVisible:false,
                // 手动添加BOM对话框是否显示
                bomDialogVisible: false,
                // 扫码添加转交物料对话框是否显示
                scanMaterialDialogVisible: false,
                // 扫码框是否显示
                innerScannerVisible: false,
                // 搜索或者扫描出来的物料，即对话框中el-table显示的物料
                material:[],
                search: '',
                // el-table中选中将要被添加的物料
                materialSelection: [],
                filterForm: {
                    filterString: '',
                    filterString2: '',
                },
                rootNode:[{id:422628,name:"test"}],
                defaultProps: {
                    children: "children",
                    label(data,node) {
                        return data.longText + ": " + data.component;
                    },
                    isLeaf: "leaf"
                },
                selectObj: {
                    checkedNode: {},
                    checkedId: []
                },
                treeData: [],
                onComplete:false,
            }
        },
        computed:{
            modelName(){
                return 'sithMesInventoryDeliveryTask'
            },
            checkedItems() {
                //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
                return this.$store.state[this.modelName]["checkedItemsPartsVo"];
            },
            selectIds() {
                //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
                return this.$store.state[this.modelName]["checkedItemsPartsVo"].join(",");
            },
        },
        methods: {
            actionDisabled(type) {
                    // 删除按钮在一条记录都没选的时候禁用
                if (type === "select") {
                        return this.checkedItems && this.checkedItems.length === 0;
                }
                    // 编辑按钮只在选择了1条记录的时候可用，其他情况下禁用
                else if (type === "selectOne") {
                    return this.checkedItems && this.checkedItems.length !== 1;
                }
            },
            gotoChild(row) {
                this.$_emGotoMixin_gotoHolderList("sithMesInventoryDeliveryMaterial"
                    , {deliveryTaskIdFilter: row.id}
                    , {deliveryTaskId: row.id}, false, {})
            },
            addBomToDeliveryTask() {
                let self = this;
                // let bomIds = this.$refs.bomTree.getBomIds();
                let bomIds = this.$refs.elBomTree.getCheckedKeys().join(",");
                let taskId = this.selectIds;
                let url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryDeliveryTask")}/addBomToDeliveryTask?ids=${taskId}&bomIds=${bomIds}`;
                this.$_emApiMixin_post(url, {})
                    .then((request) => {
                        if (request.status === 200) {
                            self.$message({
                            message: "添加成功",
                            type: "success",
                            });
                            self.bomDialogVisible = false;
                            self.$refs.emListFilter.doQuery();
                        } else {
                            self.$message({
                            message: "添加失败",
                            type: "error",
                            });
                        }
                    })
            },
            openMaterialAdd() {
                //物料太多，不能在打开dialog时就加载所有物料，先注释掉
                // this.$_emApiMixin_findByFilter("sithMesMstMaterial", {})
                // .then(data => {
                //     this.material = data;
                // })
                this.materialDialogVisible = true;
            },
            openScannerDialog() {
                this.scanMaterialDialogVisible = true;
            },
            handleSelectionChange(val) {
                this.materialSelection = val;
            },
            addMaterial() {
                let self = this;
                let materialIds = self.materialSelection.map(obj => {return obj.id}).join(',');
                let taskId = this.selectIds;
                let url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryDeliveryTask")}/addMaterialToDeliveryTask?ids=${taskId}&materialIds=${materialIds}`;
                this.$_emApiMixin_post(url, {})
                    .then((request) => {
                        if (request.status === 200) {
                            self.$message({
                            message: "添加成功",
                            type: "success",
                            });
                            self.materialDialogVisible = false;
                            self.$refs.emListFilter.doQuery();
                        } else {
                            self.$message({
                            message: "添加失败",
                            type: "error",
                            });
                        }
                    })
            },
            addScannedMaterial() {
                let self = this;
                let url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryDeliveryTask")}/addScannedMaterialToDeliveryTask?id=${self.selectIds}`;
                this.$_emApiMixin_post(url, self.material)
                    .then((request) => {
                        if (request.status === 200) {
                            self.$message({
                            message: "添加成功",
                            type: "success",
                            });
                            self.scanMaterialDialogVisible = false;
                            self.$refs.emListFilter.doQuery();
                        } else {
                            self.$message({
                            message: "添加失败",
                            type: "error",
                            });
                        }
                    })
            },
            clearMaterial() {
                this.materialSelection = [];
                this.material = [];
                this.filterForm.filterString = '';
            },
            clearBomData() {
                this.filterForm.filterString = '';
                this.treeData = [];
            },
            searchMaterial() {
                let self = this;
                let url = `${this.$_emApiMixin_entityBaseApi("sithMesMstMaterial")}/findMaterialByFilter?description=${self.filterForm.filterString}`;
                self.$_emApiMixin_get(url, {})
                .then(response => {
                    self.material = response;
                })
            },
            searchBom() {
                let self = this;
                let url = `${this.$_emApiMixin_entityBaseApi("sithMesMstBom")}/findBomByConditions`;
                let obj = new Object();
                obj.longTextFilter = self.filterForm.filterString;
                obj.componentFilter = self.filterForm.filterString2;
                self.$_emApiMixin_post(url, obj)
                .then((response) => {
                    if(response.data instanceof Array) {
                        response.data.map(item => {
                        self.treeData.push(Object.assign({},item,{children:""}))
                    })
                    }
                })
            },
            searchChildrenBoms(node,resolve) {
                let bomId = node.data.id;
                let url = `${this.$_emApiMixin_entityBaseApi("sithMesMstBom")}/findChildrenBomById?id=${bomId}`;
                this.$_emApiMixin_get(url, {})
                .then((response)=>{
                    if(response.length === 0) {
                        resolve([]);
                    } else {
                        resolve(response);
                    }

                })
            },
            loadNode(node, resolve) {
                if(node.level === 0) {
                    resolve(this.treeData);
                } else {
                    setTimeout(()=>{
                        this.searchChildrenBoms(node,resolve);
                        // let res = this.searchChildrenBoms(node.data.id);
                        // resolve(res);
                    },500)
                }
            },
            //控制单选,先不用
            checkChange(data, checked) {
                // const index = this.selectObj.checkedId.indexOf(data.id);
                // if(index <0 && this.selectObj.checkedId.length === 1 && checked) {
                //     this.$refs.bomTree.setChecked(this.selectObj.checkedNode, false);
                //     this.selectObj.selectIds = [];
                //     this.selectObj.push(data.id);
                //     this.selectObj.checkedNode = data;
                // } else if(this.selectObj.checkedId.length === 0 && checked) {
                //     this.selectObj.checkedNode = data;
                //     this.selectObj.checkedId = [];
                //     this.selectObj.checkedId.push(data.id);
                // } else if(index >= 0 && this.selectObj.checkedId.length === 1 && !checked) {
                //     this.selectObj.checkedId = [];
                // }
                console.log("bom change");
            },
            openBomDialog() {
                this.bomDialogVisible = true;
            },
            returnTasks() {
                this.onComplete = true;
                let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/returnTasks?ids=${this.selectIds}`
                this.$_emApiMixin_post(url, {})
                .then(response => {
                    commonViewsUtil.showSuccess(this, "退回成功");
                    this.$refs.emListFilter.doQuery()
                })
                .finally(() => this.onComplete = false)
            },
            closeScannerDialog() {
                this.$refs.scanner.closeCamera();
                this.$refs.scanner.resetOutputData();
                this.innerScannerVisible = false;
            },
            getCodeData(data) {
                console.log("get qr code data:" + data);
                this.innerScannerVisible = false;
                //检验二维码的数据格式
                try {
                    var obj = JSON.parse(data);
                    var description = obj['物料描述'];
                    var materialCode = obj['物料号'];
                    // var unit = obj['单位']
                    var quantityAndUnit = obj['数量']
                } catch (error) {
                    this.$message({
                    message: "无效的二维码",
                    type: "error",
                    });
                    return;
                }
                var quantity = quantityAndUnit.substring(0,quantityAndUnit.indexOf("("));
                var unit = quantityAndUnit.substring(quantityAndUnit.indexOf("(")+1,quantityAndUnit.length-1)

                let scanResult = new Object();
                scanResult.deliveryDescription = description;
                scanResult.materialCode = materialCode;
                scanResult.unit = unit;
                scanResult.quantity = quantity;
                this.material.push(scanResult);
            },
            openCamera() {
                this.innerScannerVisible = true;
                setTimeout(() => {
                    this.$refs.scanner.openCamera('');
                },500);
            }
            // noBomSelected() {
            //     return this.$refs.elBomTree.getCheckedKeys();
            // }

        },
        mounted() {
            if (this.$route.query.hasOwnProperty('deliveryNo')) {
                this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('deliveryNoFilter', this.$route.query.deliveryNo);
            }
            this.$refs.emListFilter.doQuery();
        }
    };
</script>

<style scoped>
.bom-tree {
    height: 285px;
}
.tree-bom-div {
    height: 285px;
    overflow: scroll;
}
</style>
